// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fh-0";